import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-gender-female",
  "use": "foquz-icon-gender-female-usage",
  "viewBox": "0 0 11 17",
  "content": "<symbol viewBox=\"0 0 11 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-gender-female\"><path d=\"M5.536 16v-5M8 14H3m7-8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol